import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { CampaignAlert as ApiCampaignAlert } from '../api/tapiTypes';

export type CampaignAlert = ApiCampaignAlert['attributes'];

export const campaignAlertsAdapter = createEntityAdapter<CampaignAlert>({});

export const campaignAlertsSlice = createSlice({
  name: 'campaignAlerts',
  initialState: campaignAlertsAdapter.getInitialState(),
  reducers: {
    campaignAlertsFetched: (
      state,
      {
        payload: { alerts },
      }: PayloadAction<{ campaignId: number; alerts: CampaignAlert[] }>
    ) => {
      campaignAlertsAdapter.upsertMany(state, alerts);
    },
  },
});
